import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Sign Identification questions
export const signIdentificationMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-identify-sign-1',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-1o1', text: { en: 'Traffic light ahead', nl: 'Verkeerslicht vooruit', ar: 'إشارة مرور أمامك' } },
      { id: 'q-sign-1o2', text: { en: 'Road narrows ahead', nl: 'Weg versmalt vooruit', ar: 'الطريق يضيق أمامك' } },
      { id: 'q-sign-1o3', text: { en: 'Entry not allowed / forbidden (checkpoint)', nl: 'Toegang niet toegestaan / verboden (controlepunt)', ar: 'الدخول غير مسموح / محظور (نقطة تفتيش)' } }
    ],
    correctAnswerId: 'q-sign-1o1',
    explanation: {
      en: 'This warning sign indicates a traffic light ahead. The triangular shape with red border and traffic light symbol warns drivers to be prepared to stop if the light is red.',
      nl: 'Dit waarschuwingsbord geeft een verkeerslicht vooruit aan. De driehoekige vorm met rode rand en verkeerslichtsymbool waarschuwt bestuurders om voorbereid te zijn om te stoppen als het licht rood is.',
      ar: 'تشير علامة التحذير هذه إلى إشارة مرور أمامك. الشكل المثلث مع الحدود الحمراء ورمز إشارة المرور يحذر السائقين من الاستعداد للتوقف إذا كانت الإشارة حمراء.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-1.jpg',
    imageHint: 'warning sign traffic light ahead'
  },
  {
    id: 'q-identify-sign-2',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-2o1', text: { en: 'Entry not allowed / forbidden (checkpoint)', nl: 'Toegang niet toegestaan / verboden (controlepunt)', ar: 'الدخول غير مسموح / محظور (نقطة تفتيش)' } },
      { id: 'q-sign-2o2', text: { en: 'Rail crossing ahead with more than 1 railway', nl: 'Spoorwegovergang vooruit met meer dan 1 spoor', ar: 'معبر سكة حديد أمامك مع أكثر من سكة واحدة' } },
      { id: 'q-sign-2o3', text: { en: 'Rail crossing ahead with 1 railway', nl: 'Spoorwegovergang vooruit met 1 spoor', ar: 'معبر سكة حديد أمامك مع سكة واحدة' } }
    ],
    correctAnswerId: 'q-sign-2o2',
    explanation: {
      en: 'This is a railway crossing sign indicating multiple railway tracks ahead. Drivers must stop if a train is approaching and never cross when barriers are down or warning lights are flashing. Multiple tracks mean extra caution is required.',
      nl: 'Dit is een spoorwegovergangsbord dat meerdere spoorlijnen vooruit aangeeft. Bestuurders moeten stoppen als een trein nadert en nooit oversteken wanneer bomen naar beneden zijn of waarschuwingslichten knipperen. Meerdere sporen betekenen dat extra voorzichtigheid vereist is.',
      ar: 'هذه علامة معبر سكة حديد تشير إلى مسارات سكة حديد متعددة أمامك. يجب على السائقين التوقف إذا كانت قطار تقترب وعدم العبور أبدا عندما تكون الحواجز منخفضة أو عندما تومض أضواء التحذير. المسارات المتعددة تعني أن الحذر الإضافي مطلوب.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-2.jpg',
    imageHint: 'warning sign railroad crossing multiple tracks'
  },
  {
    id: 'q-identify-sign-3',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-3o1', text: { en: 'Road narrows ahead', nl: 'Weg versmalt vooruit', ar: 'الطريق يضيق أمامك' } },
      { id: 'q-sign-3o2', text: { en: 'Road gets narrow on the right side', nl: 'Weg wordt smal aan de rechterkant', ar: 'الطريق يضيق على الجانب الأيمن' } },
      { id: 'q-sign-3o3', text: { en: 'Road narrows on the left', nl: 'Weg versmalt aan de linkerkant', ar: 'الطريق يضيق على اليسار' } }
    ],
    correctAnswerId: 'q-sign-3o1',
    explanation: {
      en: 'This warning sign indicates that the road narrows ahead. The triangular shape with red border and converging lines symbol warns drivers to reduce speed and be cautious when approaching a narrowing road.',
      nl: 'Dit waarschuwingsbord geeft aan dat de weg vooruit versmalt. De driehoekige vorm met rode rand en convergerende lijnen symbool waarschuwt bestuurders om de snelheid te verminderen en voorzichtig te zijn bij het naderen van een versmallende weg.',
      ar: 'تشير علامة التحذير هذه إلى أن الطريق يضيق أمامك. الشكل المثلث مع الحدود الحمراء ورمز الخطوط المتقاربة يحذر السائقين من تقليل السرعة والحذر عند الاقتراب من طريق ضيق.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-3.jpg',
    imageHint: 'warning sign road narrowing'
  },
  {
    id: 'q-identify-sign-4',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-4o1', text: { en: 'Warning for low flying planes, aircraft and jets', nl: 'Waarschuwing voor laagvliegende vliegtuigen en straaljagers', ar: 'تحذير من الطائرات والطائرات النفاثة منخفضة الطيران' } },
      { id: 'q-sign-4o2', text: { en: 'Traffic light ahead', nl: 'Verkeerslicht vooruit', ar: 'إشارة مرور أمامك' } },
      { id: 'q-sign-4o3', text: { en: 'Warning for pedestrians', nl: 'Waarschuwing voor voetgangers', ar: 'تحذير للمشاة' } }
    ],
    correctAnswerId: 'q-sign-4o1',
    explanation: {
      en: 'This warning sign indicates low-flying aircraft, planes, and jets. The triangular shape with red border and airplane symbol warns drivers to be aware of aircraft that may be flying at low altitudes.',
      nl: 'Dit waarschuwingsbord geeft laagvliegende vliegtuigen, vliegtuigen en straaljagers aan. De driehoekige vorm met rode rand en vliegtuigsymbool waarschuwt bestuurders om op te letten voor vliegtuigen die mogelijk op lage hoogte vliegen.',
      ar: 'تشير علامة التحذير هذه إلى الطائرات والطائرات النفاثة منخفضة الطيران. الشكل المثلث مع الحدود الحمراء ورمز الطائرة يحذر السائقين من الانتباه للطائرات التي قد تطير على ارتفاعات منخفضة.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-4.jpg',
    imageHint: 'warning sign low-flying aircraft'
  },
  {
    id: 'q-identify-sign-5',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-5o1', text: { en: 'Stop and give way to all traffic', nl: 'Stop en geef voorrang aan al het verkeer', ar: 'توقف وأعط الأولوية لجميع المرور' } },
      { id: 'q-sign-5o2', text: { en: 'Give way to all traffic', nl: 'Geef voorrang aan al het verkeer', ar: 'أعط الأولوية لجميع المرور' } },
      { id: 'q-sign-5o3', text: { en: 'Priority road', nl: 'Voorrangsweg', ar: 'طريق ذو أولوية' } }
    ],
    correctAnswerId: 'q-sign-5o1',
    explanation: {
      en: 'This is a stop sign (red octagon with white "STOP" text). Drivers must come to a complete stop and give way to all traffic before proceeding. This is one of the most important regulatory signs.',
      nl: 'Dit is een stopbord (rode achthoek met witte "STOP" tekst). Bestuurders moeten volledig stoppen en voorrang geven aan al het verkeer voordat ze verder gaan. Dit is een van de belangrijkste regelgevende borden.',
      ar: 'هذه علامة توقف (ثماني أحمر مع نص "STOP" أبيض). يجب على السائقين التوقف تماما وإعطاء الأولوية لجميع المرور قبل المتابعة. هذه واحدة من أهم العلامات التنظيمية.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-5.jpg',
    imageHint: 'stop sign'
  },
  {
    id: 'q-identify-sign-6',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-6o1', text: { en: 'Crossing for pedestrians warning ahead', nl: 'Waarschuwing voetgangersoversteekplaats vooruit', ar: 'تحذير معبر المشاة أمامك' } },
      { id: 'q-sign-6o2', text: { en: 'Warning for pedestrians', nl: 'Waarschuwing voor voetgangers', ar: 'تحذير للمشاة' } },
      { id: 'q-sign-6o3', text: { en: 'Cattle crossing', nl: 'Veeoversteekplaats', ar: 'معبر الماشية' } }
    ],
    correctAnswerId: 'q-sign-6o1',
    explanation: {
      en: 'This warning sign indicates a pedestrian crossing (zebra crossing) ahead. The triangular shape with red border and pedestrian symbol on stripes warns drivers to slow down and be prepared to yield to pedestrians.',
      nl: 'Dit waarschuwingsbord geeft een voetgangersoversteekplaats (zebrapad) vooruit aan. De driehoekige vorm met rode rand en voetgangersymbool op strepen waarschuwt bestuurders om te vertragen en voorbereid te zijn om voorrang te verlenen aan voetgangers.',
      ar: 'تشير علامة التحذير هذه إلى معبر مشاة (معبر مخطوط) أمامك. الشكل المثلث مع الحدود الحمراء ورمز المشاة على الخطوط يحذر السائقين من التباطؤ والاستعداد لإعطاء الأولوية للمشاة.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-6.jpg',
    imageHint: 'warning sign pedestrian crossing zebra'
  },
  {
    id: 'q-identify-sign-7',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-7o1', text: { en: 'Warning of poor visibility due to rain, fog or snow', nl: 'Waarschuwing voor slecht zicht door regen, mist of sneeuw', ar: 'تحذير من ضعف الرؤية بسبب المطر أو الضباب أو الثلج' } },
      { id: 'q-sign-7o2', text: { en: 'Warning for snow and sleet', nl: 'Waarschuwing voor sneeuw en natte sneeuw', ar: 'تحذير من الثلج والثلج المبلل' } },
      { id: 'q-sign-7o3', text: { en: 'Cattle crossing', nl: 'Veeoversteekplaats', ar: 'معبر الماشية' } }
    ],
    correctAnswerId: 'q-sign-7o1',
    explanation: {
      en: 'This warning sign indicates poor visibility conditions ahead due to rain, fog, or snow. The triangular shape with red border and car symbol with dots/particles warns drivers to reduce speed and increase following distance.',
      nl: 'Dit waarschuwingsbord geeft slechte zichtomstandigheden vooruit aan door regen, mist of sneeuw. De driehoekige vorm met rode rand en autosymbool met stippen/deeltjes waarschuwt bestuurders om de snelheid te verminderen en de volgafstand te vergroten.',
      ar: 'تشير علامة التحذير هذه إلى ظروف رؤية ضعيفة أمامك بسبب المطر أو الضباب أو الثلج. الشكل المثلث مع الحدود الحمراء ورمز السيارة مع النقاط/الجسيمات يحذر السائقين من تقليل السرعة وزيادة مسافة المتابعة.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-7.jpg',
    imageHint: 'warning sign poor visibility weather'
  },
  {
    id: 'q-identify-sign-8',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-8o1', text: { en: 'Cattle crossing', nl: 'Veeoversteekplaats', ar: 'معبر الماشية' } },
      { id: 'q-sign-8o2', text: { en: 'Warning for pedestrians', nl: 'Waarschuwing voor voetgangers', ar: 'تحذير للمشاة' } },
      { id: 'q-sign-8o3', text: { en: 'Crossing for pedestrians warning ahead', nl: 'Waarschuwing voetgangersoversteekplaats vooruit', ar: 'تحذير معبر المشاة أمامك' } }
    ],
    correctAnswerId: 'q-sign-8o1',
    explanation: {
      en: 'This warning sign indicates a cattle crossing ahead. The triangular shape with red border and cow symbol warns drivers to be alert for cattle that may be crossing the road. Drivers should reduce speed and be prepared to stop.',
      nl: 'Dit waarschuwingsbord geeft een veeoversteekplaats vooruit aan. De driehoekige vorm met rode rand en koe symbool waarschuwt bestuurders om alert te zijn op vee dat mogelijk de weg oversteekt. Bestuurders moeten de snelheid verminderen en voorbereid zijn om te stoppen.',
      ar: 'تشير علامة التحذير هذه إلى معبر ماشية أمامك. الشكل المثلث مع الحدود الحمراء ورمز البقرة يحذر السائقين من الانتباه للماشية التي قد تعبر الطريق. يجب على السائقين تقليل السرعة والاستعداد للتوقف.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-8.jpg',
    imageHint: 'warning sign cattle crossing'
  },
  {
    id: 'q-identify-sign-9',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-9o1', text: { en: 'Cars not allowed - prohibited', nl: 'Auto\'s niet toegestaan - verboden', ar: 'السيارات غير مسموحة - محظورة' } },
      { id: 'q-sign-9o2', text: { en: 'Vehicles - Cars prohibited', nl: 'Voertuigen - Auto\'s verboden', ar: 'المركبات - السيارات محظورة' } },
      { id: 'q-sign-9o3', text: { en: 'Entry not allowed / forbidden (checkpoint)', nl: 'Toegang niet toegestaan / verboden (controlepunt)', ar: 'الدخول غير مسموح / محظور (نقطة تفتيش)' } }
    ],
    correctAnswerId: 'q-sign-9o1',
    explanation: {
      en: 'This prohibitory sign indicates that cars are not allowed and are prohibited from entering or using this road or area. The sign shows a car symbol with a diagonal line through it, indicating that motor vehicles are forbidden.',
      nl: 'Dit verbodsbord geeft aan dat auto\'s niet zijn toegestaan en verboden zijn om deze weg of dit gebied binnen te gaan of te gebruiken. Het bord toont een autosymbool met een diagonale lijn erdoorheen, wat aangeeft dat motorvoertuigen verboden zijn.',
      ar: 'تشير علامة الحظر هذه إلى أن السيارات غير مسموحة ومحظورة من الدخول أو استخدام هذا الطريق أو المنطقة. تظهر العلامة رمز سيارة مع خط قطري من خلاله، مما يشير إلى أن المركبات الآلية محظورة.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-9.jpg',
    imageHint: 'prohibitory sign cars not allowed'
  },
  {
    id: 'q-identify-sign-10',
    text: { en: 'Identify the road sign:', nl: 'Identificeer het verkeersbord:', ar: 'حدد علامة الطريق:' },
    options: [
      { id: 'q-sign-10o1', text: { en: 'Crossroad ahead with side road to left', nl: 'Kruispunt vooruit met zijweg naar links', ar: 'تقاطع أمامك مع طريق جانبي إلى اليسار' } },
      { id: 'q-sign-10o2', text: { en: 'Crossroad ahead, side roads to right and left', nl: 'Kruispunt vooruit, zijwegen naar rechts en links', ar: 'تقاطع أمامك، طرق جانبية إلى اليمين واليسار' } },
      { id: 'q-sign-10o3', text: { en: 'Uncontrolled crossroad ahead', nl: 'Ongecontroleerd kruispunt vooruit', ar: 'تقاطع غير خاضع للسيطرة أمامك' } }
    ],
    correctAnswerId: 'q-sign-10o1',
    explanation: {
      en: 'This warning sign indicates a crossroad ahead with a side road joining from the left. The triangular shape with red border and road junction symbol warns drivers to be alert for traffic entering from the left side road. Drivers should reduce speed and be prepared to yield if necessary.',
      nl: 'Dit waarschuwingsbord geeft een kruispunt vooruit aan met een zijweg die van links aansluit. De driehoekige vorm met rode rand en wegkruisingssymbool waarschuwt bestuurders om alert te zijn op verkeer dat van de linkerzijweg binnenkomt. Bestuurders moeten de snelheid verminderen en voorbereid zijn om voorrang te verlenen indien nodig.',
      ar: 'تشير علامة التحذير هذه إلى تقاطع أمامك مع طريق جانبي ينضم من اليسار. الشكل المثلث مع الحدود الحمراء ورمز تقاطع الطرق يحذر السائقين من الانتباه للمرور الذي يدخل من الطريق الجانبي الأيسر. يجب على السائقين تقليل السرعة والاستعداد لإعطاء الأولوية إذا لزم الأمر.'
    },
    subject: 'Sign Identification',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/sign-id/q-identify-sign-10.jpg',
    imageHint: 'warning sign crossroad side road left'
  }
  ,
  {
    id: 'q-identify-sign-18',
    text: {
      en: 'What information might be added below a main road sign?',
      nl: 'Welke informatie kan onder een hoofdbord worden geplaatst?',
      ar: 'ما هي المعلومات التي يمكن إضافتها أسفل لافتة رئيسية للطرق؟'
    },
    options: [
      {
        id: 'q-sign-18o1',
        text: {
          en: 'Only advertising',
          nl: 'Alleen reclame',
          ar: 'فقط إعلانات'
        }
      },
      {
        id: 'q-sign-18o2',
        text: {
          en: 'Supplementary plates with conditions, distances, or times',
          nl: 'Onderborden met voorwaarden, afstanden of tijden',
          ar: 'لوحات إضافية توضح الشروط أو المسافات أو الأوقات'
        }
      },
      {
        id: 'q-sign-18o3',
        text: {
          en: 'Random messages',
          nl: 'Willekeurige teksten',
          ar: 'رسائل عشوائية'
        }
      }
    ],
    correctAnswerId: 'q-sign-18o2',
    explanation: {
      en: 'Supplementary plates below road signs provide additional information such as distance, time periods, conditions, or affected vehicle types. These help clarify when or how the main sign applies.',
      nl: 'Onderborden bij verkeersborden geven aanvullende informatie zoals afstand, tijdvakken, voorwaarden of voertuigcategorieën. Zo wordt duidelijk wanneer of hoe het hoofdbord geldt.',
      ar: 'اللوحات الإضافية أسفل لافتات الطريق توفر معلومات إضافية مثل المسافة أو فترات الوقت أو الشروط أو أنواع المركبات المعنية. تساعد هذه اللوحات على توضيح متى أو كيف تنطبق اللافتة الرئيسية.'
    },
    subject: 'Sign Identification'
  }
];

























